<template>
  <div>
    <v-data-table
      :key="accountsKey"
      v-model="selected"
      fixed-header
      :headers="headers"
      :items="accounts"
      :items-per-page="-1"
      :footer-props="{
        'items-per-page-options': [20, 50, 100, -1]
      }"
      height="600"
      :single-select="true"
      show-select
      class="accounts-table"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #header.email="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="accounts-table--sort-icon" />
        </div>
      </template>

      <template #header.lastAt="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="accounts-table--sort-icon" />
        </div>
      </template>

      <template #item.lastConnexion="{ item }">
        {{ item.lastConnexion ? formatTime(item.lastConnexion) : '' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { formatValues } from '@/mixins/formatValues.mixin';
import TwoArrowSort from '@/components/common/icons/TwoArrowSort';

export default {
  name: 'AccountsTable',
  components: {
    TwoArrowSort
  },
  mixins: [formatValues],
  props: {
    accounts: {
      type: Array,
      default: () => []
    },
    accountsKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      singleSelect: true,
      selected: [],
      sortBy: 'email',
      sortDesc: false
    };
  },
  computed: {
    ...mapGetters('accounts', ['changeModal']),
    headers() {
      return [
        {
          text: 'Email',
          divider: true,
          align: 'start',
          sortable: true,
          width: '30%',
          value: 'email'
        },
        {
          text: 'Zone',
          divider: true,
          align: 'start',
          sortable: false,
          width: '25%',
          value: 'zoneId'
        },
        {
          text: 'Role',
          divider: true,
          align: 'start',
          sortable: false,
          width: '25%',
          value: 'rolesId'
        },
        {
          text: 'Dernière connexion',
          divider: true,
          align: 'start',
          sortable: false,
          width: '25%',
          value: 'lastConnexion'
        }
      ];
    }
  },

  watch: {
    changeModal: {
      immediate: true,
      deep: true,
      handler() {
        if (!this.changeModal) {
          this.selected = [];
        }
      }
    },
    selected() {
      this.$emit('set-selected-id', this.selected);
    }
  }
};
</script>

<style lang="scss">
.accounts-table {
  table-layout: fixed;

  .v-data-table-header__icon {
    display: none;
  }

  .v-input--selection-controls__input {
    .v-icon {
      color: #3dd598 !important;
    }
  }

  &--sort-icon {
    min-width: 24px;
    min-height: 24px;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
  td:nth-child(1) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr:last-child {
    td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  thead {
    th {
      background-color: white;
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }

    th:nth-child(1) {
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
